import React, { FunctionComponent, SyntheticEvent, createElement, ReactElement } from 'react';
import { nanoid } from 'nanoid';
import IHashtag from '@interfaces/IHashtag';

type Renderer = (
  hashtag: string,
  onClick?: (hashtag: string, e: SyntheticEvent) => void,
) => ReactElement;

const rule = /([#|＃][^\s]+)/g;

const parse = (
  value: string,
  renderer: Renderer,
  action: (hashtag: string, e: SyntheticEvent) => void,
  source?: IHashtag[],
) => {
  if (!value) return null;
  let separator = rule;
  if (source && source.length) {
    separator = new RegExp(`(${source.map((item) => item.tag).join('|')})`, 'gi');
    return value.split(separator).map((chunk) => {
      if (chunk.match(separator)) {
        return renderer(chunk, action);
      }

      return chunk;
    });
  }
  return value.split(separator).map((chunk) => {
    if (chunk.match(separator)) {
      return renderer(chunk, action);
    }

    return chunk;
  });
};

const defaultHashtagRenderer: Renderer = (hashtag, onClick) =>
  createElement(
    'span',
    {
      key: nanoid(),
      onClick: onClick ? (e: SyntheticEvent) => onClick(hashtag, e) : null,
      className: 'clickable',
    },
    hashtag,
  );

interface TextWithHashtagsProps {
  children: string;
  onHashtagClick: (hashtag: string) => void;
  source?: IHashtag[];
}

const TextWithHashtags: FunctionComponent<TextWithHashtagsProps> = ({
  children,
  onHashtagClick,
  source,
}) => {
  const hashtagRenderer = defaultHashtagRenderer;
  const parsed = parse(children, hashtagRenderer, onHashtagClick, source);

  return <>{parsed}</>;
};

export default TextWithHashtags;
